import { SVGProps } from 'react'
const Convex = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 124.2 143.6"
    width="1em"
    height="1em"
    {...props}
  >
    <style>
      {
        '.st0{fill:#1682fe}.st1{fill:#60d8a4}.st2{fill:#f4bb3b}.st3{fill:#ff5a5a}'
      }
    </style>
    <path d="M71.8 28h10v15.1h-10zM43.1 0h10v15.1h-10z" className="st0" />
    <path d="M14.4 14.4h10v15.1h-10z" className="st1" />
    <path d="M0 71.8h10.1v43.1H0z" className="st2" />
    <path d="M0 28.7h10.1v43.1H0z" className="st1" />
    <path d="M86.1 42.4h10v15.1h-10z" className="st0" />
    <path
      d="M86.1 86.1h10v15.1h-10zM71.8 100.5h10v15.1h-10zM43.1 128.5h10v15.1h-10z"
      className="st3"
    />
    <path d="M14.4 114.1h10v15.1h-10z" className="st2" />
    <path
      d="M124.2 57.4V28.7h-14.4V14.4H81.1V0H52.4v14.4H23.7v14.4H9.3v86.1h14.4v14.4h28.7v14.4h28.7v-14.4h28.7v-14.4h14.4V86.1H95.5v14.4H81.1v14.4H52.4v-14.4H38.1V43.1h14.4V28.7h28.7v14.4h14.4v14.4h28.6z"
      style={{
        fill: '#3a3a3a',
      }}
    />
  </svg>
)
export default Convex
